import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch } from 'redux-react-hook';
import { clearLoginToken, getLoginToken } from '../../helpers/sessionHandler';
import { SetAuthenticated } from '../../store/authentication/actions';
import { DestroySession } from '../../store/global/actions';

const LogoutComponent = () => {
  const dispatch = useDispatch();
  const history = useHistory();


  useEffect(() => {
    if(getLoginToken()) {
      clearLoginToken()
      dispatch(SetAuthenticated(false));
      dispatch(DestroySession());
      history.push('/');
    }
  }, []);

  return (
      <div>
          <h2>Dziękujemy za skorzystanie z EBOK. Do zobaczenia!</h2>
      </div>
  )

}

export default LogoutComponent


// WEBPACK FOOTER //
// ./src/components/Logout/LogoutComponent.js